module.exports = __webpack_public_path__ + "img/header-theme-primary.babcd2f1.svg";